import gql from "graphql-tag";
import {OrganizationFragment} from "./Organization";
import {LocationFragment} from "./Location";
import {IsnResultWithHeaderFragment} from "./Isn";

export const VeriflytAccountFragment = gql`
    fragment VeriflytAccountFragment on VeriflytAccount {
        _id
        _rev
        classType
        createdBy
        createdTs
        modifiedBy
        modifiedTs
        veriflytID
        applicationID
        primaryName
        secondaryName
        notes
    }
`

export const TicketTemplateFragment = gql`
    fragment TicketTemplateFragment on TicketTemplate {
        _id
        _rev
        areaCode
        onScreenName
        catalogueName
        issuingAgencyTitle
        issuingAgencyPhone
        issuingAgencyPOC
        courseName
        shortDescription
        retestingPeriodInDays
        minPassingScore
        minPassingGrade
        originatorID
        originatorDoc {
            ...VeriflytAccountFragment
        }
    }
    ${VeriflytAccountFragment}
`

export const ComplianceRuleFragment = gql`
fragment ComplianceRuleFragment on ComplianceRule {
    _id
    _rev
    modifiedBy
    modifiedTs
    createdTs
    modifiedTs
    classType
    linkA
    linkB
    linkC
    linkD
    linkE
    catalogueName
    onScreenName
    shortDescription
    inEffectDate
    expirationDate
    ruleIdsThatSatisfy
    ticketTemplateIdsThatSatisfy
    ticketTemplateIdsThatSatisfyDocs {
        ...TicketTemplateFragment
    }
    isActive
}
${TicketTemplateFragment}
`

export const ComplianceTicketFragment = gql`
    fragment ComplianceTicketFragment on ComplianceTicket {
        _id
        _rev
        modifiedBy
        modifiedTs
        createdTs
        modifiedTs
        classType
        ticketTemplateID
        ticketTemplateDoc {
            ...TicketTemplateFragment
        }
        catalogueName
        onScreenName
        ticketWritersEmail
        didPass
        reasonForFailure
        completionNodes
        result_passed
        result_score
        result_grade
        completionDate
        expirationDate
        isActive
    }
    ${VeriflytAccountFragment}
    ${TicketTemplateFragment}
`

export const ComplianceRuleTypeInfoFragment = gql`
    fragment ComplianceRuleTypeInfoFragment on ComplianceRuleTypeInfo {
        name
        category
        label
    }
`

export const VeriflytStatusDetailFragment = gql`
    fragment VeriflytStatusDetailFragment on VeriflytStatusDetail {
        status
        reasonCode
        reason
        ticket {
            ...ComplianceTicketFragment
        }
        rule {
            ...ComplianceRuleFragment
        }
    }
    ${ComplianceRuleFragment}
    ${ComplianceTicketFragment}
`

export const VeriflytResultFragment = gql`
    fragment VeriflytResultFragment on VeriflytResult {
        status
        reasons
        reasonsText
        errorMessage
        failingDetails {
            ...VeriflytStatusDetailFragment
        }
        passingDetails {
            ...VeriflytStatusDetailFragment
        }
        personID
        complianceCheckContext
        checkTimeStart
        checkTimeEnd
    }
    ${VeriflytStatusDetailFragment}
`